import { Card, Row, Col, Tag, Drawer, Icon, Table } from "antd";
import React from "react";
import { connect } from "react-redux";
import { FaUniversity, FaCalendarTimes, FaFileContract, FaHandHoldingUsd } from 'react-icons/fa'
import Request from "../../request";
import { TableComp } from "sz-react-utils";



class AddedUniversityCommissions extends React.Component {
    state = {
        visible: true,
        count: 0,
        loading: false
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            this.setState({ loading: true })
            let response = await Request.getCommissionUniversities(params);
            this.setState({ count: response.total, loading: false })
            resolve(response)
        })
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    render() {
        let { visible, count, loading } = this.state;
        let { icon, bgColorClass, title } = this.props.drawerParam;
        const columns = [
            {
                title: 'Sr No.',
                key: 'serial Number',
                width: 70,
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },
            {
                title: "University",
                key: "universityInstitutionName",
                width: 210,
                dataIndex: "universityInstitutionName",
                sorter: true,
                searchTextName: "universityInstitutionName",
                filterRegex: true,
            },
            {
                title: 'Commission',
                key: 'commissionFromUniversity',
                width: 100,
                dataIndex: 'commissionFromUniversity',
                searchTextName: "universityInstitutionName",
                filterRegex: true,
            },
            {
                title: "Country",
                key: 'universityId.universityCountryName',
                dataIndex: 'universityId.universityCountryName',
                width: 120
            },
            {
                title: 'Commission Type',
                key: 'commissionTypeFrom',
                dataIndex: 'commissionTypeFrom',
                width: 120,
                filters: [{ value: 'Percentage', text: 'Percentage' }, { value: 'Flat', text: 'Flat' }]
            },
            {
                title: 'Status',
                key: 'status',
                dataIndex: 'status',
                width: 120,
                filters: [{ value: 'Active', text: 'Active' }, { value: 'Inactive', text: 'Inactive' }, { value: 'Pending', text: 'Pending' }],
                filterRegex: true
            }
        ]
        return (
            <Drawer
                title={
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '98%' }}>
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                            {/* Render the dynamic icon here. If it's a React component, it will render. */}
                            <span style={{ marginRight: 12, display: 'flex', fontSize: '20px' }}>
                                {icon ? icon : <Icon type="profile" />}
                            </span>
                            {title}
                        </span>
                        <Tag className="count-tag">{count} TOTAL</Tag>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={1000}
                visible={visible}
                className={`dynamic-drawer ${bgColorClass}`}
            >
                <Card>
                    <Table
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        loading={loading}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </Drawer>
        )
    }
}

class RelationshipManagerDashboard extends React.Component {
    state = {
        drawer: false,
        drawerParam: {},
        allUniversityCount: {
            total: 0
        },
        expiryDateMissingCount: {
            total: 0
        },
        missingAgreementFileCount: {
            total: 0
        },
        renewalExpiredCount: {
            total: 0
        },
        renewalTodayCount: {
            total: 0
        },
        renewalUpcomingCount: {
            total: 0
        },
        commissionNotAddedUniversitiesCounts: 0,
        commissionAddedUniversitiesCount: 0,
        showAddedCommission: false,
        showNotAddedCommission: false,
        universityPartnerShipCount: [],
        universityConsortiumIdCounts: []
    }

    loadApis = async () => {
        let response = await Request.getRelationShipGraphData();
        this.setState(response);
    }

    componentDidMount() {
        this.loadApis();
    }

    closeUniversityCommissionDrawer = () => {
        this.setState({ showAddedCommission: false, showNotAddedCommission: false }, () => {
            this.loadApis()
        })
    }

    render() {
        let { allUniversityCount, expiryDateMissingCount, missingAgreementFileCount, commissionAddedUniversitiesCount,
            showAddedCommission, drawerParam
        } = this.state;
        return (
            <div className="fod-container">
                {
                    showAddedCommission ?
                        <AddedUniversityCommissions drawerParam={drawerParam} onClose={this.closeUniversityCommissionDrawer} />


                        : null
                }
                <Row className="fod-row">
                    {/* Universities */}
                    <Col span={6}>
                        <div className="stat-card">
                            {/* Changed to bg-purple and FaUniversity */}
                            <div className="stat-icon-wrapper bg-purple">
                                <FaUniversity />
                            </div>

                            <div className="stat-data">
                                <div className="stat-label">Universities</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a
                                            href="/agreement-management?type=all"
                                            target='_blank'
                                            rel="noreferrer"
                                        >
                                            {allUniversityCount.total}
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* Expiry Date Missing Count */}
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-orange">
                                <FaCalendarTimes />
                            </div>

                            <div className="stat-data">
                                <div className="stat-label">Expiry Date Missing</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a
                                            href="/agreement-management?type=missingDateExpiry"
                                            target='_blank'
                                            rel="noreferrer"
                                        >
                                            {expiryDateMissingCount.total}
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* Missing Agreement */}
                    <Col span={6}>
                        <div className="stat-card">
                            {/* Using bg-red and FaFileContract to represent a critical missing document */}
                            <div className="stat-icon-wrapper bg-red">
                                <FaFileContract />
                            </div>

                            <div className="stat-data">
                                <div className="stat-label">Agreement Missing</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a
                                            href="/agreement-management?type=missingAgreement"
                                            target='_blank'
                                            rel="noreferrer"
                                        >
                                            {missingAgreementFileCount.total}
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* Commission Added Count */}
                    <Col span={6}>
                        <div className="stat-card">
                            {/* Changed to bg-green and FaHandHoldingUsd to represent positive financial data */}
                            <div className="stat-icon-wrapper bg-green">
                                <FaHandHoldingUsd />
                            </div>

                            <div className="stat-data">
                                <div className="stat-label">Commission Added</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a
                                            onClick={() => this.setState({
                                                showAddedCommission: true, drawerParam: {
                                                    title: 'Commission Added',
                                                    icon: <FaHandHoldingUsd />,
                                                    bgColorClass: 'bg-green'
                                                }
                                            })}
                                        >
                                            {commissionAddedUniversitiesCount}
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}



const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}


export default connect(mapDispatchToProps)
    (RelationshipManagerDashboard)